editGetStartedBoxController.$inject = ['$scope', '$mdDialog', 'welcomeMessage', 'entrypointDescription', 'hasWelcomeMessage', 'hasComposerInputDisabled', 'composerInputDisabled', 'isFirstConversationEverBox', 'firstConversationEverDelay'];
export function editGetStartedBoxController($scope, $mdDialog, welcomeMessage, entrypointDescription, hasWelcomeMessage, hasComposerInputDisabled, composerInputDisabled, isFirstConversationEverBox, firstConversationEverDelay) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.delayOptions = [4,5,6,7,8,9,10,11,12,13,14,15,20,30,45,60,75,90];

  init();

  function ok() {
    $mdDialog.hide($scope.model);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.model = { welcomeMessage, entrypointDescription, composerInputDisabled, firstConversationEverDelay};
    $scope.hasWelcomeMessage = hasWelcomeMessage;
    $scope.hasComposerInputDisabled = hasComposerInputDisabled;
    $scope.isFirstConversationEverBox = isFirstConversationEverBox;
    $scope.firstConversationEverDelay = firstConversationEverDelay;
  }

}
